import { createRoot } from 'react-dom/client';

import { App } from './App';
import {
    AlertContextProvider,
    DialogContextProvider,
    LoaderContextProvider,
    ProfileContextProvider
} from './contexts';
import { ThemeProvider } from '@emotion/react';
import { vdsMuiTheme } from './@vds';

declare global {
    type AptrinsicType = "identify" | "track";
    type AptrinsicParam0<T extends AptrinsicType> = T extends "identify" ? object : string;
    interface Window {
        aptrinsic: <T extends AptrinsicType, >(type: T, param0: AptrinsicParam0<T>, param1: object) => void;
    }
}
window.process = {} as any;
const rootElement = document.getElementById('root')!;
const root = createRoot(rootElement);

root.render(
    <ThemeProvider theme={vdsMuiTheme}>
        <LoaderContextProvider>
            <AlertContextProvider>
                <DialogContextProvider>
                    <ProfileContextProvider>
                        <App />
                    </ProfileContextProvider>
                </DialogContextProvider>
            </AlertContextProvider>
        </LoaderContextProvider>
    </ThemeProvider>
);
